

export const options1 = [
    { value: 'Select a View', label: 'Select a View' },
    { value: 'Contact View List', label: 'Contact View List' },
    { value: 'Contact Location View', label: 'Contact Location View' }
  ];
export  const optionssymbol = [
    { value: '$', label: '$' },
    { value: '€', label: '€' }
  ];
export  const duration = [
    { value: 'Days', label: 'Days' },
    { value: 'Month', label: 'Month' }
  ];

export const optionSalutation = [
  { value: 'MR', label: 'Mr.' },
  { value: 'MS', label: 'Ms.' },
  { value: 'MRS', label: 'Mrs.' },
  { value: 'DR', label: 'Dr.' },
  { value: 'PROF', label: 'Prof.'},
  { value: 'MX', label: 'Mx.' }
];

export const optionschoose = [
    { value: 'Work', label: 'Work' },
    { value: 'Home', label: 'Home' }
  ];
  
  export const options = [
    { value: 'NovaWave LLC', label: 'NovaWave LLC' },
    { value: 'SilverHawk', label: 'SilverHawk' },
    { value: 'SummitPeak', label: 'SummitPeak' },
    { value: 'RiverStone Ventur', label: 'RiverStone Ventur' },
    { value: 'China', label: 'China' },
  ];
  export const clientList = [
    { value: 'NovaWave LLC', label: 'NovaWave LLC' },
    { value: 'SilverHawk', label: 'SilverHawk' },
    { value: 'HarborView', label: 'HarborView' },
  ];
  export const category = [
    { value: 'Select', label: 'Select' },
    { value: 'HarborView', label: 'HarborView' },
    { value: 'LLC', label: 'LLC' },
  ];
  export const projectTiming = [
    { value: 'Select', label: 'Select' },
    { value: 'Hourly', label: 'Hourly' },
    { value: 'Minutes', label: 'Minutes' },
  ];
  
  export const optionsource = [
    { value: 'Phone Calls', label: 'Phone Calls' },
    { value: 'Social Media', label: 'Social Media' },
    { value: 'Referral Sites', label: 'Referral Sites' },
    { value: 'Web Analytics', label: 'Web Analytics' },
    { value: 'Previous Purchases', label: 'Previous Purchases' },
  ];
  export const optionindustry = [
    { value: 'AGRICULTURE', label: 'AGRICULTURE' },
    { value: 'APPAREL', label: 'APPAREL' },
    { value: 'BANKING', label: 'BANKING' },
    { value: 'BIOTECHNOLOGY', label: 'BIOTECHNOLOGY' },
    { value: 'CHEMICALS', label: 'Insurance' },
    { value: 'COMMUNICATIONS', label: 'COMMUNICATIONS' },
    { value: 'CONSTRUCTION', label: 'CONSTRUCTION' },
    { value: 'EDUCATION', label: 'EDUCATION' },
    { value: 'ELECTRONICS', label: 'ELECTRONICS' },
    { value: 'ENERGY', label: 'ENERGY' },
    { value: 'ENGINEERING', label: 'ENGINEERING' },
    { value: 'ENTERTAINMENT', label: 'ENTERTAINMENT' },
    { value: 'ENVIRONMENT', label: 'ENVIRONMENT' },
    { value: 'FINANCE', label: 'FINANCE' },
    { value: 'FOOD_BEVERAGE', label: 'FOOD_BEVERAGE' },
    { value: 'GOVERNMENT', label: 'GOVERNMENT' },
    { value: 'HEALTHCARE', label: 'HEALTHCARE' },
    { value: 'HOSPITAL', label: 'HOSPITAL' },
    { value: 'MACHINERY', label: 'MACHINERY' },
    { value: 'INSURANCE', label: 'INSURANCE' },
    { value: 'MANUFACTURING', label: 'MANUFACTURING' },
    { value: 'MEDIA', label: 'MEDIA' },
    { value: 'NOT_FOR_PROFIT', label: 'NOT_FOR_PROFIT' },
    { value: 'OTHER', label: 'OTHER' },
    { value: 'RECREATION', label: 'RECREATION' },
    { value: 'RETAIL', label: 'RETAIL' },
    { value: 'SHIPPING', label: 'SHIPPING' },
    { value: 'TECHNOLOGY', label: 'TECHNOLOGY' },
    { value: 'TELECOMMUNICATIONS', label: 'TELECOMMUNICATIONS' },
    { value: 'TRANSPORTATION', label: 'TRANSPORTATION' },
    { value: 'UTILITIES', label: 'UTILITIES' }
  ];
  export const optiondeals = [
    { value: 'Collins', label: 'Collins' },
    { value: 'Konopelski', label: 'Konopelski' },
    { value: 'Adams', label: 'Adams' },
    { value: 'Schumm', label: 'Schumm' },
    { value: 'Wisozk', label: 'Wisozk' },
  ];
 export const languageOptions = [
    { value: 'ENGLISH', label: 'ENGLISH' },
    { value: 'FRENCH', label: 'FRENCH' },
    { value: 'SPANISH', label: 'SPANISH' },
    { value: 'GERMAN', label: 'GERMAN' },
    { value: 'ITALIAN', label: 'ITALIAN' },
    { value: 'PORTUGUESE', label: 'PORTUGUESE' },
    { value: 'RUSSIAN', label: 'RUSSIAN' },
    { value: 'CHINESE', label: 'CHINESE' },
    { value: 'JAPANESE', label: 'JAPANESE' },
    { value: 'KOREAN', label: 'KOREAN' },
    { value: 'ARABIC', label: 'ARABIC' },
    { value: 'HINDI', label: 'HINDI' },
    { value: 'VIETNAMESE', label: 'VIETNAMESE' },
    { value: 'THAI', label: 'THAI' },
    { value: 'INDONESIAN', label: 'INDONESIAN' },
    { value: 'TURKISH', label: 'TURKISH' },
    { value: 'GREEK', label: 'GREEK' }
];

export const ratingOptions = [
  { value: "1", label: "COLD" },
  { value: "2", label: "WARM" },
  { value: "3", label: "HOT" },
];
export const genderOptions = [
  { value: "MALE", label: "MALE" },
  { value: "FEMALE", label: "FEMALE" },
  { value: "OTHER", label: "OTHER" },
];
 export const optionsowner = [
    { label: 'Jerald', value: 'Jerald', image: 'assets/img/profiles/avatar-14.jpg' },
    { label: 'Sharon Roy', value: 'Sharon Roy', image: 'assets/img/profiles/avatar-20.jpg' },
    { label: 'Vaughan', value: 'Vaughan', image: 'assets/img/profiles/avatar-21.jpg' },
    { label: 'Jessica', value: 'Jessica', image: 'assets/img/profiles/avatar-23.jpg' },
    { label: 'Carol Thomas', value: 'Carol Thomas', image: 'assets/img/profiles/avatar-16.jpg' }
  ];
 export const optionsowner1 = [
    { label: 'Darlee Robertson', value: 'Jerald', image: 'assets/img/profiles/avatar-19.jpg' },
    { label: 'Sharon Roy', value: 'Sharon Roy', image: 'assets/img/profiles/avatar-20.jpg' },
    { label: 'Vaughan', value: 'Vaughan', image: 'assets/img/profiles/avatar-21.jpg' },
    { label: 'Jessica', value: 'Jessica', image: 'assets/img/profiles/avatar-23.jpg' },
    { label: 'Carol Thomas', value: 'Carol Thomas', image: 'assets/img/profiles/avatar-16.jpg' }
  ];

export  const countryoptions1 = [
    { value: 'India', label: 'India' },
    { value: 'USA', label: 'USA' },
    { value: 'France', label: 'France' },
    { value: 'UK', label: 'UK' },
    { value: 'UAE', label: 'UAE' },

  ];
  export const lastModified  = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "Ascending", label: "Ascending" },
    { value: "Descending", label: "Descending" },
    { value: "Recently Viewed", label: "Recently Viewed" },
    { value: "Recently Added", label: "Recently Added" },
    { value: "Creation Date", label: "Creation Date" },
  ];
  export const recent  = [
    { value: "sortByDate", label: "Recent" },
    { value: "Last Modified", label: "Last Modified" },
    { value: "Last Modified by me", label: "Last Modified by me" },
  ];
  export const companyName = [
    { value: 'novaWave', label: 'NovaWave LLC' },
    { value: 'blueSky', label: 'BlueSky Industries' },
    { value: 'silverHawk', label: 'SilverHawk' },
    { value: 'summitPeak', label: 'SummitPeak' },
    { value: 'riverStone', label: 'RiverStone Ventur' }
  ];

  export const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
        "Last 30 Days": [
            new Date("2020-07-12T04:57:17.076Z"),
            new Date("2020-08-10T04:57:17.076Z"),
        ],
        "Last 7 Days": [
            new Date("2020-08-04T04:57:17.076Z"),
            new Date("2020-08-10T04:57:17.076Z"),
        ],
        "Last Month": [
            new Date("2020-06-30T18:30:00.000Z"),
            new Date("2020-07-31T18:29:59.999Z"),
        ],
        "This Month": [
            new Date("2020-07-31T18:30:00.000Z"),
            new Date("2020-08-31T18:29:59.999Z"),
        ],
        Today: [
            new Date("2020-08-10T04:57:17.076Z"),
            new Date("2020-08-10T04:57:17.076Z"),
        ],
        Yesterday: [
            new Date("2020-08-09T04:57:17.076Z"),
            new Date("2020-08-09T04:57:17.076Z"),
        ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
};



export const salestypelist  = [
  { value: 'sales', label: 'Sales' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'calls', label: 'Calls' }
];
export const status  = [
  { value: 'OPEN', label: 'Open' },
  { value: 'LOST', label: 'Lost' },
  { value: 'WON', label: 'Won' },
];
export const project  = [
  { value: 'Devops Design', label: 'Devops Design' },
  { value: 'MargrateDesign', label: 'MargrateDesign' },
  { value: 'UI for Chat', label: 'UI for Chat' },
  { value: 'Web Chat', label: 'Web Chat' },
];
export const defaultValues = [
  { value: 'Devops Design', label: 'Devops Design' },
  { value: 'MargrateDesign', label: 'MargrateDesign' },
  { value: 'UI for Chat', label: 'UI for Chat' }
];

export const socialMedia  = [
  { value: 'Select', label: 'Select' },
  { value: 'Google', label: 'Google' },
  { value: 'Social Media', label: 'Social Media' },
];
export const priorityList  = [
  { value: 'Select', label: 'Select' },
  { value: 'Highy', label: 'Highy' },
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
];
export const tagInputValues = [
  { value: 'Devops Design', label: 'Devops Design' },
  { value: 'MargrateDesign', label: 'MargrateDesign' },
];
export const projectType = [
  { value: 'Mobile App', label: 'Mobile App' },
  { value: 'Meeting', label: 'Meeting' },
];
export const status1 = [
  { value: 'Mobile App', label: 'Mobile App' },
  { value: 'Meeting', label: 'Meeting' },
];
export const activeList = [
  { value: 'Select', label: 'Select' },
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];
export const ascendingandDecending = [
  { value: 'Sort By Date', label: 'Sort By Date' },
  { value: 'Ascending', label: 'Ascending' },
  { value: 'Descending', label: 'Descending' },
];
export const statusList = [
  { value: 'SUCCESS', label: 'Success' },
  { value: 'BUSY', label: 'Busy' },
  { value: 'UNAVAILABLE', label: 'Unavailable' },
  { value: 'NO_ANSWER', label: 'No Answer' },
  { value: 'WRONG_NUMBER', label: 'Wrong Number' },
  { value: 'LEFT_VOICE_MESSAGE', label: 'Left Voice Message' },
  { value: 'MOVING_FORWARD', label: 'Moving Forward' },
];
export const owner = [
  { value: 'Jerald', label: 'Jerald' },
  { value: 'Guillory', label: 'Guillory' },
  { value: 'Jami', label: 'Jami' },
  { value: 'Theresa', label: 'Theresa' },
  { value: ' Espinosa', label: ' Espinosa' },
];
export const assigneeOption = [
  { value: 'Darlee Robertson', label: 'Darlee Robertson', image: 'assets/img/profiles/avatar-19.jpg' },
  { value: 'Sharon Roy', label: 'Sharon Roy', image: 'assets/img/profiles/avatar-20.jpg' },
  { value: 'Vaughan', label: 'Vaughan', image: 'assets/img/profiles/avatar-21.jpg' },
  { value: 'Jessica', label: 'Jessica', image: 'assets/img/profiles/avatar-23.jpg' },
  { value: 'Carol Thomas', label: 'Carol Thomas', image: 'assets/img/profiles/avatar-16.jpg' }
];
export const ratings = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
];
export const priority = [
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
]
export const statusOption = [
  { value: 'Closed', label: 'Closed' },
  { value: 'Open', label: 'Open' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Resolved', label: 'Resolved' },
];
export const newselectOption = [
  { value: 'Select', label: 'Select' },
  { value: 'Truelysell', label: 'Truelysell' },
  { value: 'Dreamsports', label: 'Dreamsports' },
  { value: 'Doccure', label: 'Doccure' },
  { value: 'Kofejob', label: 'Kofejob' },
];
export const releatdselectOption = [
  { value: 'Select', label: 'Select' },
  { value: 'Truelysell', label: 'Truelysell' },
  { value: 'Dreamsports', label: 'Dreamsports' },
  { value: 'Doccure', label: 'Doccure' },
  { value: 'Kofejob', label: 'Kofejob' },
  { value: 'Best@laundry', label: 'Best@laundry' },
];
export const editreleatdselectOption = [
  { value: 'Select', label: 'Select' },
  { value: 'Deals', label: 'Deals' },
  { value: 'Truelysell', label: 'Truelysell' },
  { value: 'Dreamsports', label: 'Dreamsports' },
  { value: 'Doccure', label: 'Doccure' },
  { value: 'Kofejob', label: 'Kofejob' },
  { value: 'Best@laundry', label: 'Best@laundry' },
];
export const dealsselectOption = [
  { value: 'Select', label: 'Select' },
  { value: 'Collins', label: 'Collins' },
  { value: 'Best@laundry', label: 'Best@laundry' },
  { value: 'Dreamsports', label: 'Dreamsports' },
  { value: 'Doccure', label: 'Doccure' },
  { value: 'Kofejob', label: 'Kofejob' },
 
];
export const currency = [
  { value: '$', label: '$' },
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
]
export const contracts = [
  { value: 'Contracts under Seal', label: 'Contracts under Seal' },
  { value: 'Meeting', label: 'Meeting' },
]
export const documentType = [
  { value: 'Contract', label: '1' },
  { value: 'Proposal', label: '2' },
  { value: 'Quote', label: '3' },
]
export const LocaleData = [
  { value: 'en', label: '1' },
  { value: 'es', label: '2' },
  { value: 'ru', label: '3' },
]
export const accountType = [
  { value: 'Gmail', label: '1' },
  { value: 'Outlook', label: '2' },
  { value: 'Imap', label: '3' },
]
export const client = [
  { value: 'Harbor View', label: 'Harbor View' },
  { value: 'CoastalStar Co.', label: 'CoastalStar Co.' },
  { value: 'RiverStone Ventur.', label: 'RiverStone Ventur.' },
]
export const contracttype = [
  { value: 'Contracts under Seal', label: 'Contracts under Seal' },
  { value: 'Contract', label: 'Contract' },
  { value: 'RiverStone Ventur', label: 'RiverStone Ventur' },
]
export const currencyselect= [
  { value: '$', label: '$' },
  { value: 'INR', label: 'INR' },
  { value: 'Euro', label: 'Euro' },
]
export const selectAssignType = [
  { value: 'LEAD', label:'Leads'},
  { value: 'CONTACT', label:'Contacts'}
]
export const selectRelatedToType = [
  { value: 'ACCOUNT', label:'Companies'},
  { value: 'OPPORTUNITY', label:'Opportunities'}
]
export const selectTaskCategoryOptions = [
  { value: 'CALLS', label:'Calls'},
  { value: 'FOLLOW-UP', label:'Follow Up'},
  { value: 'EMAIL', label:'Email'},
  { value: 'MEETING', label:'Meeting'},
  { value: 'OTHER', label:'Other'}
]
export const selectTaskStatusOptions = [
  { value: 'NOT-START', label:'Not Start'},
  { value: 'PENDING', label:'Pending'},
  { value: 'IN-PROGRESS', label:'In Progress'},
  { value: 'COMPLETED', label:'Completed'},
  { value: 'OVERDUE', label:'Overdue'}
]
export const selectTaskPriorityOptions = [
  { value: 'LOW', label:'LOW'},
  { value: 'MEDIUM', label:'MEDIUM'},
  { value: 'HIGH', label:'HIGH'}
]



